export const initialState = {
  otpRequested: false,
  otpCode: "",
  personalNumber: "",
  medium: "email",
  userData: {},
  lookingUp: false,
  fetching: false,
  inputErrors: null,
  serverMessage: null
};

const addCustomerModalReducer = (state, action) => {
  switch (action.type) {
    case "reset":
      return initialState;
    case "handleInput":
      return {
        ...state,
        [action.field]: action.payload,
        // inputErrors: { ...state.inputErrors, [action.field]: null },
        serverMessage: null
      };
    case "lookingUp":
      return { ...state, [action.type]: action.payload };
    case "fetching":
      return { ...state, [action.type]: action.payload };
    case "handleInputErrors":
      return { ...state, inputErrors: action.payload };
    case "handleServerError":
      return {
        ...state,
        fetching: false,
        serverMessage: { type: "error", text: action.payload }
      };
    case "handleOtpSent":
      return {
        ...state,
        fetching: false,
        inputErrors: null,
        serverMessage: null,
        otpRequested: true
      };
    case "handleServerSuccess":
      return {
        ...state,
        fetching: false,
        serverMessage: { type: "success", text: action.payload }
      };
    default:
      return state;
  }
};

export default addCustomerModalReducer;
